<template>
    <div
        v-if="isVisible"
        data-testid="checkout-attempts-modal"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/65"
    >
        <div class="bg-bg border-stroke-1 mx-4 w-full max-w-md border shadow-xl">
            <div class="p-4">
                <h2
                    class="font-title mb-6 text-center text-base font-bold tracking-wide text-white uppercase"
                >
                    {{ $t('checkout_attempts.darts_on_double') }}
                </h2>

                <div
                    class="grid gap-4"
                    :class="{
                        'grid-cols-4': availableAttempts.length === 4,
                        'grid-cols-3': availableAttempts.length === 3,
                        'grid-cols-2': availableAttempts.length === 2,
                        'grid-cols-1': availableAttempts.length === 1,
                    }"
                >
                    <button
                        v-for="attemptCount in availableAttempts"
                        :key="attemptCount"
                        @click="onAttemptCountSelect(attemptCount)"
                        data-testid="checkout-attempt-option"
                        class="flex h-12 items-center justify-center border text-white transition-colors"
                        :class="
                            selectedAttempt === attemptCount
                                ? 'border-red-600 bg-red-600/20'
                                : 'border-stroke-1 hover:border-red-600'
                        "
                        :disabled="isSubmitting"
                    >
                        <div class="text-base">{{ attemptCount }}</div>
                    </button>
                </div>
            </div>

            <div class="border-stroke-1 mt-2 flex flex-col gap-3 border-t p-4">
                <DiagonalCutButton
                    @click="onConfirm"
                    variant="primary"
                    cut-position="left-top"
                    :disabled="isSubmitting || selectedAttempt === null"
                    class="w-full"
                    data-testid="checkout-attempts-confirm"
                >
                    {{ $t('checkout_darts.confirm') }}
                </DiagonalCutButton>
                <DiagonalCutButton
                    @click="onCancel"
                    variant="secondary"
                    cut-position="right-top"
                    :disabled="isSubmitting"
                    class="w-full"
                >
                    {{ $t('checkout_attempts.cancel') }}
                </DiagonalCutButton>
            </div>
        </div>
    </div>
</template>

<script>
import DiagonalCutButton from '@/components/ui/DiagonalCutButton.vue'

export default {
    name: 'CheckoutAttemptsModal',
    components: { DiagonalCutButton },
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        availableAttempts: {
            type: Array,
            default: () => [0, 1, 2, 3],
        },
        isSubmitting: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['select', 'cancel'],
    data() {
        return {
            selectedAttempt: null,
        }
    },
    watch: {
        isVisible(visible) {
            if (!visible) {
                this.selectedAttempt = null
            }
        },
    },
    methods: {
        onAttemptCountSelect(attemptCount) {
            if (!this.isSubmitting) {
                this.selectedAttempt = attemptCount
            }
        },
        onConfirm() {
            if (!this.isSubmitting && this.selectedAttempt !== null) {
                this.$emit('select', this.selectedAttempt)
            }
        },
        onCancel() {
            if (!this.isSubmitting) {
                this.$emit('cancel')
            }
        },
    },
}
</script>
